import { useSuspenseQuery } from "@apollo/client";
import { createFileRoute } from "@tanstack/react-router";

import { Section, SectionHeader } from "@roqua/components/sections";

import { PageTitle } from "@/components/PageTitle";
import { Timeline } from "@/components/Timeline";
import { BackButton } from "@/components/ui/BackButton";
import { SelfInitiableMeasuredQuestionnairesForRespondent } from "@/features/Timeline/SelfInitiableMeasuredQuestionnaires/SelfInitiableMeasuredQuestionnairesForRespondent";
import { SelfInitiableMeasuredQuestionnairesPageQuery } from "@/features/Timeline/SelfInitiableMeasuredQuestionnaires/SelfInitiableMeasuredQuestionnairesPageQuery";
import { useTranslation } from "@/i18n/client";
import { useSessionContext } from "@/session";

export const Route = createFileRoute(
  "/$organizationKey/$dossierId/self_initiable_measured_questionnaires",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { dossierId } = useSessionContext();
  const { data } = useSuspenseQuery(SelfInitiableMeasuredQuestionnairesPageQuery, {
    variables: { dossierId },
  });
  const respondents = data.dossier.respondents;

  const { t } = useTranslation("Timeline");

  return (
    <>
      <PageTitle title="selfInitiableMeasuredQuestionnaires" />
      <Section variant="header">
        <SectionHeader
          header={t("selfInitiable.header")}
          buttons={<BackButton href="/$organizationKey/$dossierId" />}
        />

        <p>{t("selfInitiable.description")}</p>
      </Section>

      <Section>
        <Timeline>
          {respondents.map((respondent) => (
            <SelfInitiableMeasuredQuestionnairesForRespondent
              key={respondent.id}
              respondent={respondent}
            />
          ))}
        </Timeline>
      </Section>
    </>
  );
}
